export const Nav = () => (
  <nav
    data-testid="main-nav"
    className="fixed top-0 left-0 right-0 z-50 bg-[#14213D]/95 backdrop-blur-md border-b border-white/10"
  >
    <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
      <a href="/" data-testid="nav-logo" className="flex items-center gap-3">
        <img src="/assets/veristamp_icon_master.svg" alt="" width="36" height="36" className="h-9 w-9 rounded-lg" />
        <span className="font-heading font-extrabold text-[#F7F6F2] text-lg tracking-wide">VERISTAMP</span>
      </a>
      <div className="hidden md:flex items-center gap-8 text-sm text-[#F7F6F2]/80">
        <a href="#how-it-works" data-testid="nav-how-link" className="hover:text-[#C9A227] transition-colors duration-300">How it works</a>
        <a href="#trust" data-testid="nav-trust-link" className="hover:text-[#C9A227] transition-colors duration-300">Why it's different</a>
        <a href="#pricing" data-testid="nav-pricing-link" className="hover:text-[#C9A227] transition-colors duration-300">Pricing</a>
        <a href="#faq" data-testid="nav-faq-link" className="hover:text-[#C9A227] transition-colors duration-300">FAQ</a>
      </div>
      <a
        href="#download"
        data-testid="nav-download-btn"
        className="bg-[#C9A227] text-[#14213D] font-heading font-bold text-sm px-5 py-2.5 rounded-full transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md"
      >
        Get the app
      </a>
    </div>
  </nav>
);
